import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed top-0 left-0 z-10 h-screen w-screen bg-nucleus-lightestBlue" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "flex pb-4" }
const _hoisted_4 = { class: "mr-2 w-1/2" }
const _hoisted_5 = { class: "ml-2 w-1/2" }
const _hoisted_6 = { class: "flex items-center px-4 py-6 border-b" }
const _hoisted_7 = { class: "text-2xl" }
const _hoisted_8 = { class: "px-4 py-6 overflow-y-auto scroll-box" }
const _hoisted_9 = { class: "border-b pt-2 mb-4" }
const _hoisted_10 = { class: "text-lg pb-2 text-nucleus-grey font-semibold" }
const _hoisted_11 = { class: "flex relative" }
const _hoisted_12 = { class: "mr-2 w-1/4" }
const _hoisted_13 = { class: "ml-2 w-3/4" }
const _hoisted_14 = { class: "border-b pt-2 mb-4" }
const _hoisted_15 = { class: "text-lg pb-2 text-nucleus-grey font-semibold" }
const _hoisted_16 = { class: "border-b pt-2 mb-4" }
const _hoisted_17 = { class: "text-lg pb-2 text-nucleus-grey font-semibold" }
const _hoisted_18 = { class: "border-b pt-2 mb-4" }
const _hoisted_19 = { class: "text-lg pb-2 text-nucleus-grey font-semibold" }
const _hoisted_20 = { class: "border-b pt-2 mb-4" }
const _hoisted_21 = { class: "text-lg pb-2 text-nucleus-grey font-semibold" }
const _hoisted_22 = { class: "flex relative" }
const _hoisted_23 = { class: "mr-2 w-1/4" }
const _hoisted_24 = { class: "ml-2 w-3/4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMini = _resolveComponent("HeaderMini")!
  const _component_HeaderShadow = _resolveComponent("HeaderShadow")!
  const _component_ButtonSecondary = _resolveComponent("ButtonSecondary")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectCountry = _resolveComponent("SelectCountry")!
  const _component_ErrorBox = _resolveComponent("ErrorBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderMini, {
      name: _ctx.$t('global.defaults.addTenancy'),
      to: { name: 'tenancies' },
      "no-menu": true
    }, null, 8, ["name"]),
    _createVNode(_component_HeaderShadow),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addTenancy && _ctx.addTenancy(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: "/service-admin/tenancies" }, {
              default: _withCtx(() => [
                _createVNode(_component_ButtonSecondary, {
                  type: "button",
                  name: _ctx.$t('buttons.cancel'),
                  disabled: _ctx.loading
                }, null, 8, ["name", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              type: "submit",
              name: _ctx.$t('global.defaults.addTenancy'),
              disabled: 
                !_ctx.required(_ctx.tenancy.name) ||
                !_ctx.required(_ctx.tenancy.region) ||
                !_ctx.required(_ctx.tenancy.language) ||
                !_ctx.required(_ctx.tenancy.contact.name) ||
                !_ctx.validateEmail(_ctx.tenancy.contact.email) ||
                !_ctx.required(_ctx.tenancy.api.version) ||
                !_ctx.required(_ctx.tenancy.api.username) ||
                !_ctx.required(_ctx.tenancy.api.password) ||
                !_ctx.required(_ctx.localAdmin.name) ||
                !_ctx.validateEmail(_ctx.localAdmin.email) ||
                !_ctx.required(_ctx.localAdmin.phone) ||
                !_ctx.validatePhoneNumberTenant(
                  _ctx.tenancy.contact.countryCode,
                  _ctx.tenancy.contact.phone
                ) ||
                !_ctx.validatePhoneNumberAdmin(
                  _ctx.localAdmin.countryCode,
                  _ctx.localAdmin.phone
                ) ||
                _ctx.loading
              ,
              loading: _ctx.loading
            }, null, 8, ["name", "disabled", "loading"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-nucleus-white transition-all", { 'opacity-50': _ctx.loading }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-3xl leading-none p-2 mr-6 flex self-center transition bg-nucleus-primaryBlue text-nucleus-white rounded-full icon-tenancy" }, null, -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("global.defaults.newTenancy")), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Input, {
              id: "tenant-name",
              value: _ctx.tenancy.name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tenancy.name) = $event)),
              "input-type": "text",
              label: _ctx.$t('inputs.tenancyName.label'),
              "max-length": _ctx.inputMaxLengths.name,
              placeholder: _ctx.$t('inputs.tenancyName.placeholder'),
              required: ""
            }, null, 8, ["value", "label", "max-length", "placeholder"]),
            _createVNode(_component_Select, {
              id: "tenant-region",
              value: _ctx.tenancy.region,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tenancy.region) = $event)),
              label: _ctx.$t('inputs.region.label'),
              options: _ctx.regions,
              required: ""
            }, null, 8, ["value", "label", "options"]),
            _createVNode(_component_Select, {
              id: "tenant-language",
              value: _ctx.tenancy.language,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tenancy.language) = $event)),
              label: _ctx.$t('inputs.language.label'),
              options: _ctx.languages,
              required: ""
            }, null, 8, ["value", "label", "options"]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("pages.tenancy.contactDetails")), 1)
            ]),
            _createVNode(_component_Input, {
              id: "contact-name",
              value: _ctx.tenancy.contact.name,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tenancy.contact.name) = $event)),
              "input-type": "text",
              label: _ctx.$t('inputs.name.label'),
              "max-length": _ctx.inputMaxLengths.name,
              placeholder: _ctx.$t('inputs.name.placeholder'),
              required: ""
            }, null, 8, ["value", "label", "max-length", "placeholder"]),
            _createVNode(_component_Input, {
              id: "contact-email",
              value: _ctx.tenancy.contact.email,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tenancy.contact.email) = $event)),
              "update:value": _ctx.validateEmail(_ctx.tenancy.contact.email),
              "input-type": "text",
              label: _ctx.$t('inputs.email.label'),
              "max-length": _ctx.inputMaxLengths.email,
              placeholder: _ctx.$t('inputs.email.placeholder'),
              error: _ctx.error.tenancy.contact.email,
              required: ""
            }, null, 8, ["value", "update:value", "label", "max-length", "placeholder", "error"]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_SelectCountry, {
                  id: "contact-phone-code",
                  value: _ctx.tenancy.contact.countryCode,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tenancy.contact.countryCode) = $event)),
                  label: _ctx.$t('inputs.code.label'),
                  options: _ctx.countryCodes,
                  "options-common": _ctx.countryCodesCommon
                }, null, 8, ["value", "label", "options", "options-common"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Input, {
                  id: "contact-phone",
                  value: _ctx.tenancy.contact.phone,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tenancy.contact.phone) = $event)),
                  "update:value": 
                    _ctx.validatePhoneNumberTenant(
                      _ctx.tenancy.contact.countryCode,
                      _ctx.tenancy.contact.phone
                    )
                  ,
                  "input-type": "text",
                  label: _ctx.$t('inputs.phone.label'),
                  icon: "",
                  "max-length": _ctx.inputMaxLengths.phone,
                  placeholder: _ctx.$t('inputs.phone.placeholder'),
                  error: _ctx.error.tenancy.contact.phone
                }, null, 8, ["value", "update:value", "label", "max-length", "placeholder", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("pages.tenancy.sessionSettings")), 1)
            ]),
            _createVNode(_component_Input, {
              id: "max-broadcasts",
              value: _ctx.tenancy.maxBroadcasts,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tenancy.maxBroadcasts) = $event)),
              "input-type": "number",
              label: _ctx.$t('inputs.maxBroadcasts.label'),
              "max-length": _ctx.inputMaxLengths.maxBroadcasts,
              placeholder: _ctx.$t('inputs.maxBroadcasts.placeholder')
            }, null, 8, ["value", "label", "max-length", "placeholder"]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("pages.tenancy.apiDetails")), 1)
            ]),
            _createVNode(_component_Select, {
              id: "api-version",
              value: _ctx.tenancy.api.version,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tenancy.api.version) = $event)),
              label: _ctx.$t('inputs.apiVersion.label'),
              options: _ctx.apiVersionOptions,
              required: ""
            }, null, 8, ["value", "label", "options"]),
            _createVNode(_component_Input, {
              id: "api-username",
              value: _ctx.tenancy.api.username,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tenancy.api.username) = $event)),
              "input-type": "text",
              label: _ctx.$t('inputs.apiUsername.label'),
              "max-length": _ctx.inputMaxLengths.name,
              placeholder: _ctx.$t('inputs.apiUsername.placeholder'),
              autocomplete: "off",
              required: ""
            }, null, 8, ["value", "label", "max-length", "placeholder"]),
            _createVNode(_component_Input, {
              id: "api-password",
              value: _ctx.tenancy.api.password,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tenancy.api.password) = $event)),
              "input-type": _ctx.passwordInputType,
              label: _ctx.$t('inputs.apiPassword.label'),
              icon: _ctx.passwordIcon,
              "max-length": _ctx.inputMaxLengths.password,
              placeholder: _ctx.$t('inputs.apiPassword.placeholder'),
              autocomplete: "new-password",
              required: "",
              onUpdateInputType: _cache[11] || (_cache[11] = ($event: any) => (
                (_ctx.passwordInputType = $event.type), (_ctx.passwordIcon = $event.icon)
              ))
            }, null, 8, ["value", "input-type", "label", "icon", "max-length", "placeholder"]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("pages.tenancy.licenseDetails")), 1)
            ]),
            _createVNode(_component_Input, {
              id: "license",
              value: _ctx.tenancy.license,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.tenancy.license) = $event)),
              "input-type": "text",
              label: _ctx.$t('inputs.license.label'),
              "max-length": _ctx.inputMaxLengths.name,
              placeholder: _ctx.$t('inputs.license.placeholder'),
              autocomplete: "off",
              required: ""
            }, null, 8, ["value", "label", "max-length", "placeholder"]),
            _createVNode(_component_Input, {
              id: "license-expiry",
              value: _ctx.tenancy.licenseExpiry,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.tenancy.licenseExpiry) = $event)),
              "input-type": "date",
              label: _ctx.$t('inputs.licenseExpiry.label'),
              autocomplete: "off",
              required: ""
            }, null, 8, ["value", "label"]),
            _createVNode(_component_Input, {
              id: "initialCredits",
              value: _ctx.tenancy.initialCredits,
              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.tenancy.initialCredits) = $event)),
              "input-type": "number",
              label: _ctx.$t('inputs.licenseCredits.label'),
              "max-length": _ctx.inputMaxLengths.credits,
              placeholder: _ctx.$t('inputs.licenseCredits.placeholder'),
              autocomplete: "off",
              required: ""
            }, null, 8, ["value", "label", "max-length", "placeholder"]),
            _createVNode(_component_Input, {
              id: "allowance-warning-threshold",
              value: _ctx.tenancy.allowanceWarningThreshold,
              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.tenancy.allowanceWarningThreshold) = $event)),
              "input-type": "number",
              label: _ctx.$t('inputs.allowanceWarningThreshold.label'),
              "max-length": _ctx.inputMaxLengths.allowanceWarningThreshold,
              placeholder: _ctx.$t('inputs.allowanceWarningThreshold.placeholder')
            }, null, 8, ["value", "label", "max-length", "placeholder"]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("pages.tenancy.firstUser")), 1)
            ]),
            _createVNode(_component_Input, {
              id: "user-name",
              value: _ctx.localAdmin.name,
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.localAdmin.name) = $event)),
              "input-type": "text",
              label: _ctx.$t('inputs.name.label'),
              "max-length": _ctx.inputMaxLengths.name,
              placeholder: _ctx.$t('inputs.name.placeholder'),
              required: ""
            }, null, 8, ["value", "label", "max-length", "placeholder"]),
            _createVNode(_component_Input, {
              id: "user-email",
              value: _ctx.localAdmin.email,
              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.localAdmin.email) = $event)),
              "update:value": _ctx.validateEmail(_ctx.localAdmin.email),
              "input-type": "text",
              label: _ctx.$t('inputs.email.label'),
              "max-length": _ctx.inputMaxLengths.email,
              placeholder: _ctx.$t('inputs.email.placeholder'),
              error: _ctx.error.localAdmin.email,
              required: ""
            }, null, 8, ["value", "update:value", "label", "max-length", "placeholder", "error"]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_SelectCountry, {
                  id: "user-phone-code",
                  value: _ctx.localAdmin.countryCode,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.localAdmin.countryCode) = $event)),
                  label: _ctx.$t('inputs.code.label'),
                  options: _ctx.countryCodes,
                  "options-common": _ctx.countryCodesCommon
                }, null, 8, ["value", "label", "options", "options-common"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Input, {
                  id: "user-phone",
                  value: _ctx.localAdmin.phone,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.localAdmin.phone) = $event)),
                  "update:value": 
                    _ctx.validatePhoneNumberAdmin(
                      _ctx.localAdmin.countryCode,
                      _ctx.localAdmin.phone
                    )
                  ,
                  "input-type": "text",
                  label: _ctx.$t('inputs.phone.label'),
                  icon: "",
                  "max-length": _ctx.inputMaxLengths.phone,
                  placeholder: _ctx.$t('inputs.phone.placeholder'),
                  error: _ctx.error.localAdmin.phone,
                  required: ""
                }, null, 8, ["value", "update:value", "label", "max-length", "placeholder", "error"])
              ])
            ])
          ])
        ], 2)
      ], 32),
      (_ctx.errorHeading || _ctx.errorContent)
        ? (_openBlock(), _createBlock(_component_ErrorBox, {
            key: 0,
            heading: _ctx.errorHeading,
            content: _ctx.errorContent,
            fixed: _ctx.errorFixed,
            onCloseError: _cache[21] || (_cache[21] = ($event: any) => {
          _ctx.errorHeading = '';
          _ctx.errorContent = '';
        })
          }, null, 8, ["heading", "content", "fixed"]))
        : _createCommentVNode("", true)
    ])
  ]))
}